import axios from "axios";

const API = String(process.env.REACT_APP_API_URL || "")
  .trim()
  .replace(/\/+$/, "");

/**
 * Inicia OAuth Google. Si se pasa email, Google preselecciona esa cuenta (login_hint).
 * Redirige la ventana superior (CRM iframe → top).
 */
export async function startGoogleOAuth({ email = "", confirmReconnect = true } = {}) {
  const hint = String(email || "").trim().toLowerCase();
  if (hint && confirmReconnect) {
    const ok = window.confirm(
      `Vas a reconectar Google.\n\nInicia sesión con: ${hint}\n\n` +
        "Se actualizarán los tokens y se conservará el historial de correo."
    );
    if (!ok) return { cancelled: true };
  }

  const res = await axios.post(`${API}/auth/google/start`, {
    loginHint: hint || undefined,
    email: hint || undefined,
  });
  const url = res.data?.url;
  if (!url || typeof url !== "string") {
    throw new Error("El servidor no devolvió una URL OAuth válida.");
  }

  if (window.top) {
    window.top.location.href = url;
  } else {
    window.location.href = url;
  }
  return { ok: true };
}

export function accountsNeedingGoogleReauth(accounts) {
  return (accounts || []).filter((acc) => {
    const type = String(acc.account_type || "google").toLowerCase();
    if (type === "imap") return false;
    return (
      acc.auth_status === "reauth_required" ||
      acc.auth_status === "missing_tokens"
    );
  });
}
